import React, { Component } from 'react';

class FilterCategory extends Component {

	constructor(props)
	{
		super(props);
		
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(e)
	{
		e.preventDefault();
		this.props.onCategoryChange(this.props.value);
	}

	render()
	{
		var classes = ['filter-toggle'];

		if (this.props.selected === this.props.value)
		{
			classes.push('filter-toggle--active');
		}

		return (
			<a href="#" onClick={ this.handleClick } className={classes.join(' ')}>{ this.props.name }</a>
		);
	}
}

export default FilterCategory;
